var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs, _setting;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "loader",
    width: 424,
    height: 424,
    viewBox: "0 0 424 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 423,
    height: 423,
    stroke: "url(#paint0_linear_68_117)",
    strokeDasharray: "0,0,0,1692"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,1692;            0,846,846,0;            1692,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 27.5,
    width: 369,
    height: 369,
    stroke: "url(#paint1_linear_68_117)",
    strokeDasharray: "0,0,0,1476"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,1476;            0,738,738,0;            1476,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 55.5,
    width: 313,
    height: 313,
    stroke: "url(#paint2_linear_68_117)",
    strokeDasharray: "0,0,0,1252"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,1252;            0,626,626,0;            1252,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 90.5,
    width: 243,
    height: 243,
    stroke: "url(#paint3_linear_68_117)",
    strokeDasharray: "0,0,0,972"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,972;            0,486,486,0;            972,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 120.5,
    width: 183,
    height: 183,
    stroke: "url(#paint4_linear_68_117)",
    strokeDasharray: "0,0,0,732"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,732;            0,366,366,0;            732,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 148.5,
    y: 148.5,
    width: 127,
    height: 127,
    stroke: "url(#paint5_linear_68_117)",
    strokeDasharray: "0,0,0,508"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,508;            0,254,254,0;            508,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 164.5,
    width: 95,
    height: 95,
    stroke: "url(#paint6_linear_68_117)",
    strokeDasharray: "0,0,0,380"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,380;            0,190,190,0;            380,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 179.5,
    width: 65,
    height: 65,
    stroke: "url(#paint7_linear_68_117)",
    strokeDasharray: "0,0,0,260"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,260;            0,130,130,0;            260,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 194.5,
    y: 194.5,
    width: 35,
    height: 35,
    stroke: "url(#paint8_linear_68_117)",
    strokeDasharray: "0,0,0,140"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "6.25s",
    values: "0,0,0,140;            0,70,70,0;            140,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_117",
    x1: 212,
    y1: 1,
    x2: 212,
    y2: 423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_117",
    x1: 212,
    y1: 28,
    x2: 212,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_117",
    x1: 212,
    y1: 56,
    x2: 212,
    y2: 368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_117",
    x1: 212,
    y1: 91,
    x2: 212,
    y2: 333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_68_117",
    x1: 212,
    y1: 121,
    x2: 212,
    y2: 303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_68_117",
    x1: 212,
    y1: 149,
    x2: 212,
    y2: 275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_68_117",
    x1: 212,
    y1: 165,
    x2: 212,
    y2: 259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_68_117",
    x1: 212,
    y1: 180,
    x2: 212,
    y2: 244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_68_117",
    x1: 212,
    y1: 195,
    x2: 212,
    y2: 229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8EEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430F44"
  })))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":5,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.23f4849b2361f795d61c55232055e450.svg";
export { ForwardRef as ReactComponent };